interface Props {
    color: string;
    width?: number;
    height?: number;
}

const FacebookIcon = ({ color = "var(--text-primary)", width = 39, height = 39 }: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5.75H5.42857L6 3.75H4V2.75C4 2.235 4 1.75 5.14286 1.75H6V0.0700001C5.81371 0.0485001 5.11029 0 4.36743 0C2.816 0 1.71429 0.8285 1.71429 2.35V3.75H0V5.75H1.71429V10H4V5.75Z" fill={color}/>
        </svg>
    )
}

export default FacebookIcon;